var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddItemIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8025",
    "data-name": "Group 8025",
    transform: "translate(-1643 -115)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2076",
    "data-name": "Ellipse 2076",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(1643 115)",
    fill: "#734bd1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8024",
    "data-name": "Group 8024",
    transform: "translate(45.5 17.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_1353",
    "data-name": "Line 1353",
    d: "M32,3H0A3,3,0,0,1-3,0,3,3,0,0,1,0-3H32a3,3,0,0,1,3,3A3,3,0,0,1,32,3Z",
    transform: "translate(1605.5 121.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1354",
    "data-name": "Line 1354",
    d: "M32,3H0A3,3,0,0,1-3,0,3,3,0,0,1,0-3H32a3,3,0,0,1,3,3A3,3,0,0,1,32,3Z",
    transform: "translate(1621.5 105.5) rotate(90)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddItemIcon);
export default __webpack_public_path__ + "static/media/addItemIcon.1275cfa8c6144e0501524e21e2067e9c.svg";
export { ForwardRef as ReactComponent };